export const remToPixel = (remValue: number, insertPostfix = true) =>
  `${remValue * 16}${insertPostfix ? 'px' : ''}`

export const getMediaQuery = (
  remValue: number,
  property: 'min-width' | 'max-width',
) => `(${property}: ${remToPixel(remValue)})`

export const breakpoints = {
  up(remValue: number, insertMediaPrefix = true) {
    return (
      (insertMediaPrefix ? '@media ' : '') +
      getMediaQuery(remValue, 'min-width')
    )
  },

  down(remValue: number, insertMediaPrefix = true) {
    return (
      (insertMediaPrefix ? '@media ' : '') +
      getMediaQuery(remValue - 1 / 16, 'max-width')
    )
  },
}
